import { Link } from 'react-router-dom';
import { Briefcase, Users, Shield, ArrowRight, CheckCircle2 } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export default function HowItWorksPage() {
  return (
    <div className="max-w-5xl mx-auto px-4 md:px-6 py-10 space-y-10">
      <div className="text-center">
        <h1 className="text-3xl md:text-5xl font-bold text-[#0B1220]">Comment ça marche</h1>
        <p className="text-slate-600 mt-3">3 étapes simples. En confiance. Partout en RDC.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {[{
          n: 1, icon: Briefcase, color: 'bg-[#EAF3FF] text-[#1677F2]', title: 'Publiez', desc: "Décrivez votre besoin en 1 minute. C'est gratuit. Vous recevez les propositions."
        }, {
          n: 2, icon: Users, color: 'bg-[#DFF7EA] text-[#16764A]', title: 'Trouvez', desc: 'Comparez les jobeurs vérifiés, lisez les avis, discutez dans la messagerie intégrée.'
        }, {
          n: 3, icon: Shield, color: 'bg-[#FFF6C7] text-[#7A5F00]', title: 'Réalisez', desc: "Payez en sécurité via la plateforme. Les fonds ne sont libérés qu'après votre validation."
        }].map((s) => (
          <Card key={s.n} className="p-6">
            <div className={`h-12 w-12 rounded-xl ${s.color} flex items-center justify-center mb-3`}><s.icon size={22} /></div>
            <p className="text-xs font-bold text-slate-500">ÉTAPE {s.n}</p>
            <h3 className="font-semibold text-xl mt-1">{s.title}</h3>
            <p className="text-sm text-slate-600 mt-2">{s.desc}</p>
          </Card>
        ))}
      </div>

      <Card className="p-6 bg-[#F2F8FF] border-[#C7E2FF]">
        <h2 className="text-xl font-bold">Structure des paiements — en toute transparence</h2>
        <p className="text-sm text-slate-600 mt-2">Chaque devis distingue deux types de montants :</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          <Card className="p-4">
            <p className="font-semibold text-[#0E3F80]">Main d&apos;œuvre (MO)</p>
            <p className="text-xs text-slate-600 mt-1">Rémunération du travail — fixée librement par le jobeur. Commission Job Kongo de <strong>10%</strong> répartie :</p>
            <ul className="text-xs mt-2 space-y-0.5 text-slate-700 list-disc list-inside">
              <li>3% Assurance & garanties</li><li>2% Fonctionnement</li><li>3% Salaires</li><li>1% Marketing</li><li>1% Œuvres sociales</li>
            </ul>
          </Card>
          <Card className="p-4">
            <p className="font-semibold text-[#16764A]">Frais annexes (FA)</p>
            <p className="text-xs text-slate-600 mt-1">Matériaux, transport, location d&apos;outils… avec justificatif (photo de reçu).</p>
            <ul className="text-xs mt-2 space-y-0.5 text-slate-700 list-disc list-inside">
              <li>Exonérés des 10%</li><li>Seulement 3% d&apos;assurance</li>
            </ul>
          </Card>
        </div>
      </Card>

      <div className="text-center">
        <Button asChild size="lg" className="bg-[#1677F2] hover:bg-[#0F5FCC]">
          <Link to="/signup">Commencer gratuitement <ArrowRight size={16} className="ml-1" /></Link>
        </Button>
      </div>
    </div>
  );
}
